// eslint-disable-next-line import/prefer-default-export
export const resumeActions = {
  RESUME__FETCH: 'RESUME__FETCH',
};
